import React,{useState} from 'react';

import ExpenseForm from './ExpenseForm';
import './Newexpense.css';

const NewExpense = (props) => {

const [isEditing,setEditing] = useState(false);

  const saveExpenseDataHandler = (enteredExpenseData) => {
    const expenseData = {
      ...enteredExpenseData,
      id: Math.random().toString()
    };
    props.onAddExpense(expenseData);
    setEditing(false);
  };

  const startEditingHandler = () => {
    setEditing(true);
  };


  const stopeditingHandler = () =>  {
    setEditing(false);


  }

  return (
    <div className='new-expense'>
      { !isEditing && <button onClick={startEditingHandler}>Add New Expense</button>}
      {isEditing && <ExpenseForm onSaveExpenseData={saveExpenseDataHandler}   oncancel ={stopeditingHandler}/> }
    </div>
  );
};

export default NewExpense;